module.exports = __webpack_public_path__ + "img/plWai.de397cd4.svg";